var _circle, _rect, _circle2, _rect2, _circle3, _rect3, _circle4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicadelogolandscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 30,
    viewBox: "0 0 108 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.9666,
    cy: 7.88652,
    r: 1.70488,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.26172,
    y: 10.2969,
    width: 3.40977,
    height: 9.17109,
    rx: 1.70488,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0195,
    cy: 7.88652,
    r: 1.70488,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3147,
    y: 10.2969,
    width: 3.40977,
    height: 9.17109,
    rx: 1.70488,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9637,
    cy: 12.0018,
    r: 1.70488,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2588,
    y: 14.5297,
    width: 3.40977,
    height: 5.05586,
    rx: 1.70488,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9637,
    cy: 22.1135,
    r: 1.70488,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.984 5.7H38.752L40.432 17.724H40.48L42.16 5.7H45.928V22.5H43.432V9.78H43.384L41.464 22.5H39.256L37.336 9.78H37.288V22.5H34.984V5.7ZM51.7381 22.74C50.4581 22.74 49.4821 22.38 48.8101 21.66C48.1381 20.924 47.8021 19.876 47.8021 18.516V5.7H50.4421V18.708C50.4421 19.284 50.5541 19.7 50.7781 19.956C51.0181 20.212 51.3541 20.34 51.7861 20.34C52.2181 20.34 52.5461 20.212 52.7701 19.956C53.0101 19.7 53.1301 19.284 53.1301 18.708V5.7H55.6741V18.516C55.6741 19.876 55.3381 20.924 54.6661 21.66C53.9941 22.38 53.0181 22.74 51.7381 22.74ZM60.9863 22.74C59.7063 22.74 58.7383 22.38 58.0823 21.66C57.4263 20.924 57.0983 19.876 57.0983 18.516V17.556H59.5943V18.708C59.5943 19.796 60.0503 20.34 60.9623 20.34C61.4103 20.34 61.7463 20.212 61.9703 19.956C62.2103 19.684 62.3303 19.252 62.3303 18.66C62.3303 17.956 62.1703 17.34 61.8503 16.812C61.5303 16.268 60.9383 15.62 60.0743 14.868C58.9863 13.908 58.2263 13.044 57.7943 12.276C57.3623 11.492 57.1463 10.612 57.1463 9.636C57.1463 8.308 57.4823 7.284 58.1543 6.564C58.8263 5.828 59.8023 5.46 61.0823 5.46C62.3463 5.46 63.2983 5.828 63.9383 6.564C64.5943 7.284 64.9223 8.324 64.9223 9.684V10.38H62.4263V9.516C62.4263 8.94 62.3143 8.524 62.0903 8.268C61.8663 7.996 61.5383 7.86 61.1063 7.86C60.2263 7.86 59.7863 8.396 59.7863 9.468C59.7863 10.076 59.9463 10.644 60.2663 11.172C60.6023 11.7 61.2023 12.34 62.0663 13.092C63.1703 14.052 63.9303 14.924 64.3463 15.708C64.7623 16.492 64.9703 17.412 64.9703 18.468C64.9703 19.844 64.6263 20.9 63.9383 21.636C63.2663 22.372 62.2823 22.74 60.9863 22.74ZM66.484 5.7H69.124V22.5H66.484V5.7ZM74.8212 22.74C73.5572 22.74 72.5892 22.38 71.9172 21.66C71.2612 20.94 70.9332 19.924 70.9332 18.612V9.588C70.9332 8.276 71.2612 7.26 71.9172 6.54C72.5892 5.82 73.5572 5.46 74.8212 5.46C76.0852 5.46 77.0452 5.82 77.7012 6.54C78.3732 7.26 78.7092 8.276 78.7092 9.588V11.364H76.2132V9.42C76.2132 8.38 75.7732 7.86 74.8932 7.86C74.0132 7.86 73.5732 8.38 73.5732 9.42V18.804C73.5732 19.828 74.0132 20.34 74.8932 20.34C75.7732 20.34 76.2132 19.828 76.2132 18.804V16.236H78.7092V18.612C78.7092 19.924 78.3732 20.94 77.7012 21.66C77.0452 22.38 76.0852 22.74 74.8212 22.74ZM82.3287 5.7H85.9047L88.6407 22.5H86.0007L85.5207 19.164V19.212H82.5207L82.0407 22.5H79.5927L82.3287 5.7ZM85.2087 16.932L84.0327 8.628H83.9847L82.8327 16.932H85.2087ZM89.9215 5.7H93.9535C95.2655 5.7 96.2495 6.052 96.9055 6.756C97.5615 7.46 97.8895 8.492 97.8895 9.852V18.348C97.8895 19.708 97.5615 20.74 96.9055 21.444C96.2495 22.148 95.2655 22.5 93.9535 22.5H89.9215V5.7ZM93.9055 20.1C94.3375 20.1 94.6655 19.972 94.8895 19.716C95.1295 19.46 95.2495 19.044 95.2495 18.468V9.732C95.2495 9.156 95.1295 8.74 94.8895 8.484C94.6655 8.228 94.3375 8.1 93.9055 8.1H92.5615V20.1H93.9055ZM99.6715 5.7H106.872V8.1H102.312V12.54H105.936V14.94H102.312V20.1H106.872V22.5H99.6715V5.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicadelogolandscape);
export default __webpack_public_path__ + "static/media/Musicade+logo+landscape.3292dfe140073547d84c75c2a8a88525.svg";
export { ForwardRef as ReactComponent };